import React from 'react'
import { useTranslation } from 'react-i18next'

import { BuildCircle, FiberNew, Palette as PaletteIcon, QuestionMark } from '@mui/icons-material'
import { Avatar } from '@mui/material'

import { GRTooltip } from '../../../../components/GRTooltip/GRTooltip'
import { LiveEventEvolutionTypeEnum } from '../../types/LiveEventCollection'
import { getLiveEventEvolutionTypeTranslation } from '../../utils/utils'
import './LiveEventEvolutionTypeChip.scss'

interface LiveEventEvolutionTypeChipProps {
  type: LiveEventEvolutionTypeEnum
  colorHex?: string
}

export const LiveEventEvolutionTypeChip: React.FC<LiveEventEvolutionTypeChipProps> = ({ type, colorHex }) => {
  const { t } = useTranslation()

  const getIcon = () => {
    switch (type) {
      case LiveEventEvolutionTypeEnum.Highlighted:
        return <FiberNew />
      case LiveEventEvolutionTypeEnum.Reskin:
        return <PaletteIcon />
      case LiveEventEvolutionTypeEnum.MechanicChange:
        return <BuildCircle />
      default:
        return <QuestionMark />
    }
  }

  return (
    <GRTooltip
      content={
        type === LiveEventEvolutionTypeEnum.Highlighted
          ? t('live-events:live_event_evolution_type_first_appearance')
          : t(getLiveEventEvolutionTypeTranslation(type) || '')
      }
    >
      {type === LiveEventEvolutionTypeEnum.Highlighted ? (
        <div className="LiveEventEvolutionTypeChip LiveEventEvolutionTypeChip--highlighted" style={{ backgroundColor: colorHex, borderColor: colorHex }}>
          {getIcon()}
        </div>
      ) : (
        <Avatar className="LiveEventEvolutionTypeChip" data-type={type}>
          {getIcon()}
        </Avatar>
      )}
    </GRTooltip>
  )
}
